const tailLayout = {
  wrapperCol: {
    offset: 10,
    span: 16,
  },
};
const layout = {
  labelCol: {
    span: 3,
  },
  wrapperCol: {
    span: 20,
  },
};

export { layout, tailLayout };
